import { MediaMatcher } from '@angular/cdk/layout';
import {ChangeDetectorRef, Component,OnDestroy,AfterViewInit} from '@angular/core';
import { MenuItems } from '../../core/shared/menu-items/menu-items';
import { ColissessionService } from '../../core/services/colissession/colissession.service';


/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: []
})
export class FullComponent implements OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  userinfo: any;

  private _mobileQueryListener: () => void;
  sessionNumber: any;
  sessiondetail: any;

  sidenavWidth = 4;
  // ngStyle: string;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher, private sessionservice: ColissessionService,
    public menuItems: MenuItems
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    // this.mobileQuery = media.matchMedia('(min-width: 900px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    // this.getuserinfo();

    let personid: any = localStorage.getItem('userinfo');
    personid = JSON.parse(personid);
    if (localStorage.getItem('session') == null){
      this.sessionNumber = personid[0].sessionid;
    }else{
      this.sessionNumber = localStorage.getItem('session');
    }
    if (this.sessionNumber != null){
      this.getsessioninfo(this.sessionNumber);
    }

  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  ngAfterViewInit(): any {}

  getuserinfo(): any {
    this.userinfo = localStorage.getItem('userinfo');
    this.userinfo = JSON.parse(this.userinfo);
  }

  getsessioninfo(session: any): any {
    this.sessionservice.getsessiondetail(session).subscribe((response: any) => {
      this.sessiondetail = response;
      // console.log('session ', this.sessiondetail);
    });
  }

  increase() {
    this.sidenavWidth = 15;
    console.log('increase sidenav width');
  }
  decrease() {
    this.sidenavWidth = 4;
    console.log('decrease sidenav width');
  }
}
